import { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useHandleLogout } from '../hooks/useHandleLogout';
import { useCloseOnOutsideClick } from '../hooks/useCloseOnOutsideClick';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import { Button } from './general/Button';
import useCurrentUser from '../hooks/useCurrentUser';
import JAKioskLogo from '../assets/JA-Kiosk.svg';

export const Header = () => {
  const currentUser = useCurrentUser();

  const [profileMenuActive, setProfileMenuActive] = useState(false);

  const headerRef = useRef(null);

  useCloseOnOutsideClick({
    ref: headerRef,
    open: profileMenuActive,
    setOpen: setProfileMenuActive,
  });

  const handleLogout = useHandleLogout();

  return (
    <header
      className="flex w-full items-center justify-between bg-white border-b-2 border-gray-200 px-12 py-4"
      ref={headerRef}
    >
      <NavLink to="/" className="flex items-center overflow-hidden relative no-underline w-fit">
        <img src={JAKioskLogo} alt="JA Kiosk Icon" className="h-16 w-16 object-contain mr-2" />
        <h1 className="text-3xl font-bold text-navy">
          JA <span className="text-teal">Kiosk</span>
        </h1>
      </NavLink>

      {currentUser?.isActive && (
        <div className="relative">
          <div
            className="flex cursor-pointer items-center gap-2 hover:opacity-80 transition-opacity"
            onClick={() => setProfileMenuActive(!profileMenuActive)}
          >
            <UserCircleIcon className="h-8 w-8 text-cyan-500" />
            <p className="hidden lg:block text-cyan-500 font-medium">{currentUser?.firstName}</p>
          </div>

          {profileMenuActive && (
            <div className="absolute right-0 z-50 mt-2 w-56 bg-white rounded-lg border-2 border-gray-200 shadow-lg p-4">
              <div className="flex flex-col gap-2">
                <Button small onClick={handleLogout}>
                  Logout
                </Button>
              </div>
            </div>
          )}
        </div>
      )}
    </header>
  );
};
